import React from "react";

import { useWindowDimensions } from "../../../../hooks";
import {
  Container,
  TitleCardContainer,
  SummaryCardContainer,
  TitleWrap,
  BgColorDiv,
  TitleText,
  SubTitleText,
  DescriptionText,
  ResponsiveTitleWrapMD,
  ResponsiveTitleWrapSM,
} from "./styled";

const FranchiseOwnerSummarySection = () => {
  const { width } = useWindowDimensions();

  return (
    <Container>
      <ResponsiveTitleWrapSM>
        <TitleCardContainer>
          <TitleWrap>
            <BgColorDiv />
            <TitleText>Why Franchise</TitleText>
          </TitleWrap>
          <TitleWrap>
            <BgColorDiv />
            <TitleText>Owners Love</TitleText>
          </TitleWrap>
          <TitleWrap>
            <BgColorDiv />
            <TitleText>Classy Closets</TitleText>
          </TitleWrap>
        </TitleCardContainer>
      </ResponsiveTitleWrapSM>
      <ResponsiveTitleWrapMD>
        <TitleCardContainer>
          <TitleWrap>
            <BgColorDiv />
            <TitleText>Why Franchise Owners</TitleText>
          </TitleWrap>
          <TitleWrap>
            <BgColorDiv />
            <TitleText>Love Classy Closets</TitleText>
          </TitleWrap>
        </TitleCardContainer>
      </ResponsiveTitleWrapMD>
      <SummaryCardContainer pleft={40}>
        <SubTitleText>STRONG ECONOMIC OUTLOOK</SubTitleText>
        <DescriptionText>
          Demand for custom cabinetry continues to grow. And as a Classy Closets
          franchise owner, you will be in the perfect position to meet that
          demand with customized solutions for your customers.
        </DescriptionText>
      </SummaryCardContainer>
      <SummaryCardContainer>
        <SubTitleText>PROVEN BUSINESS MODEL</SubTitleText>
        <DescriptionText>
          You will be trained in our business model including product design and
          installation. You will also receive our state of the art design
          software along with our CRM and scheduling software to seamlessly
          schedule design and installation appointments.
        </DescriptionText>
      </SummaryCardContainer>
      <SummaryCardContainer pleft={40}>
        <SubTitleText>UNPARALLELED SELECTION</SubTitleText>
        <DescriptionText>
          In addition to our best-in-class custom closets, Classy Closets will
          allow you to offer beautiful custom designs for every room in the
          house, including home offices and garages.
        </DescriptionText>
      </SummaryCardContainer>
    </Container>
  );
};

export default FranchiseOwnerSummarySection;
